export default "__VITE_ASSET__BIlw_jhA__"